import { render } from "./AcademicsView.vue?vue&type=template&id=40142534&scoped=true"
import script from "./AcademicsView.vue?vue&type=script&lang=js"
export * from "./AcademicsView.vue?vue&type=script&lang=js"

import "./AcademicsView.vue?vue&type=style&index=0&id=40142534&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40142534"]])

export default __exports__